import React, { useState } from 'react';

const INVISIBLE_CHAR = 'ㅤ';

const InvisibleText = () => {
  const [inputText, setInputText] = useState('');
  const [invisibleText, setInvisibleText] = useState('');
  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Invisible Text'); 

  const handleInputChange = (e) => {
    setInputText(e.target.value);
  };

  const handleGenerateInvisibleText = () => {
    const invisibleString = new Array(inputText.length).fill(INVISIBLE_CHAR).join('');
    const wrappedInvisibleText = `"${invisibleString}"`;
    setInvisibleText(wrappedInvisibleText);
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(invisibleText).then(
      () => {
        setCopyButtonLabel('Copied!');
        setTimeout(() => setCopyButtonLabel('Copy Invisible Text'), 1500); 
      },
      (err) => {
        alert('Failed to copy text: ' + err);
      }
    );
  };

  const handleClear = () => {
    setInputText('');
    setInvisibleText('');
  };

  
  const calculateTextStats = (text) => {
    const totalCharacters = text.length;
    const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
    const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
    const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
    const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;

    return {
      totalCharacters,
      totalCharactersWithoutSpace,
      totalWords,
      totalParagraphs,
      totalSentences,
    };
  };

  const stats = calculateTextStats(inputText);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
      <div className="form-group">
        <textarea
          id="inputText"
          style={{ height: '10rem' }}
          className="form-control mb-3"
          rows="4"
          value={inputText}
          onChange={handleInputChange}
          placeholder="Enter some text"
        />
      </div>

      <h4>Invisible Text:</h4>

      <div className="mb-4">
        <textarea
          className="form-control mb-4"
          style={{ height: '10rem' }}
          value={invisibleText}
          readOnly
        />
      </div>

      <div className="d-flex align-items-center mb-3">
        <button className="btn btn-primary" onClick={handleGenerateInvisibleText}>
          Generate Invisible Text
        </button>
        <button className="btn btn-primary" onClick={handleCopyClick}>
          {copyButtonLabel}
        </button>
        <button className="btn btn-danger" onClick={handleClear}>
          Clear
        </button>
      </div>

      <div className="mt-3 text-muted">
        <p>
          Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}
        </p>
        <p>
          Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
        </p>
      </div>
    </div>
  );
};

export default InvisibleText;

